/**
 * Noche Video Section
 * Handles video playback with custom play/pause controls
 */

class NocheVideoPlayer {
  constructor() {
    this.setupVideos();
  }

  setupVideos() {
    const videos = document.querySelectorAll('[data-video-id^="noche-"]');

    videos.forEach((video) => {
      const videoId = video.dataset.videoId;
      const wrapper = video.closest('.noche-video__video-wrapper');

      if (!wrapper) return;

      const playBtn = wrapper.querySelector('[data-action="play"]');
      const pauseBtn = wrapper.querySelector('[data-action="pause"]');

      if (playBtn) {
        playBtn.addEventListener('click', () => {
          this.handlePlay(video, playBtn, pauseBtn, wrapper);
        });
      }

      if (pauseBtn) {
        pauseBtn.addEventListener('click', () => {
          this.handlePause(video, playBtn, pauseBtn, wrapper);
        });
      }

      // Autoplay muted on load
      video.muted = true;
      video.play().catch(() => {});

      // Sync button states with video events
      video.addEventListener('play', () => {
        this.updateButtonStates(true, playBtn, pauseBtn, wrapper);
      });

      video.addEventListener('pause', () => {
        this.updateButtonStates(false, playBtn, pauseBtn, wrapper);
      });

      video.addEventListener('ended', () => {
        this.updateButtonStates(false, playBtn, pauseBtn, wrapper);
      });
    });
  }

  handlePlay(video, playBtn, pauseBtn, wrapper) {
    video.muted = false;
    video.volume = 1;
    video.currentTime = 0;

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          this.updateButtonStates(true, playBtn, pauseBtn, wrapper);
        })
        .catch((error) => {
          console.error('Video play failed:', error);
        });
    }
  }

  handlePause(video, playBtn, pauseBtn, wrapper) {
    video.pause();
    this.updateButtonStates(false, playBtn, pauseBtn, wrapper);
  }

  updateButtonStates(isPlaying, playBtn, pauseBtn, wrapper) {
    if (wrapper) wrapper.classList.toggle('is-playing', isPlaying);
    
    if (isPlaying) {
      if (pauseBtn) pauseBtn.style.display = 'flex';
    } else {
      if (pauseBtn) pauseBtn.style.display = 'none';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new NocheVideoPlayer();
  });
} else {
  new NocheVideoPlayer();
}

// Re-initialize when Shopify loads/reloads a section in the editor
document.addEventListener('shopify:section:load', () => {
  new NocheVideoPlayer();
});
